export default __webpack_public_path__ + "static/media/account-supervisor.cf226b35.svg";